(function ($) {
    $(document).ready(function () {
        // Accordion interaction on membership landing page
        $('.list-group-membership-faq li').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            if ($this.hasClass('active')) {
                return;
            }

            $('.collapse-membership-faq-answer').not($this).collapse('hide');
            $($this.data('target')).collapse('show');
            $('.list-group-membership-faq li').not($this).removeClass('active');
            $this.addClass('active');
        });

        // Form submission for membership application
        if ($('#form-create-membership').length) {
            grecaptcha.ready(function() {
                grecaptcha.execute(rissb_var.recaptcha_site_key, {action: 'membership_form'}).then(function(token) {
                    RISSB.var.recaptchaToken = token;
                });
            });

            var $createMembershipForm = RISSB.fn.ajaxForm({
                form: '#form-create-membership',
                beforeSubmitCb: function (arr, $form, options) {
                    var canSubmit = parseInt($('[name="can_submit"]').val(), 10) === 1;

                    if (!canSubmit) {
                        $('[name="recaptcha_token"]').val(RISSB.var.recaptchaToken);
                        $('#modal-create-membership-confirmation').modal('show');
                    }

                    return canSubmit;
                },
                completeCb: function () {
                    $('[name="can_submit"]').val(0);
                }
            });

            $(document).on('click', '#modal-create-membership-confirmation .btn-primary', function (e) {
                $('#modal-create-membership-confirmation').modal('hide');
                $('[name="can_submit"]').val(1);
                $createMembershipForm.trigger('submit');
            });
        }

        if ($('.js-form-membership').length) {
            var sameAddressFields = [
                'postal_address_is_company_address',
                'poc_office_address_is_company_address',
                'account_office_address_is_company_address',
                'ceo_office_address_is_company_address',
            ];

            $.each(sameAddressFields, function (ind, val) {
                $('[name="' + val + '"]').on('change', function () {
                    var $this     = $(this);
                    var isChecked = $this.is(':checked');
                    var key       = val.split('_')[0];
                    var fields = [
                        'address',
                        'suburb',
                        'state',
                        'postcode',
                        'country'
                    ];

                    $.each(fields, function (i, field) {
                        var $input;

                        if (key === 'postal') {
                            $input = $('[name="' + key + '_' + field +'"]');
                        } else {
                            $input = $('[name="' + key + '_office_' + field +'"]');
                        }

                        if (isChecked) {
                            $input.val('');
                            RISSB.fn.clearFormError($('.js-form-membership'), $input.attr('name'));
                        }

                        $input.prop('disabled', isChecked);
                    });
                }).change();
            });

            $('[name="company_status[]"]').on('change', function (e) {
                var $this  = $(this);
                var status = $this.filter(':checked').val();
                var selected_statuses = $('input[name="company_status[]"]:checked').map(function () {
                    return $(this).val();
                }).get();

                if (typeof status === 'undefined') {
                    //$('.form-group-apply_for_associate_membership').toggleClass('d-none', $.inArray(rissb_var.exclusive_company_status, selected_statuses) === -1);
                    return;
                }

                if (status === rissb_var.exclusive_company_status) {
                    $('[name="company_status[]"]').not($this).prop('checked', false);
                    //$('.form-group-apply_for_associate_membership').toggleClass('d-none', $.inArray(rissb_var.exclusive_company_status, selected_statuses) === -1);
                } else {
                    $('[name="company_status[]"][value="' + rissb_var.exclusive_company_status +'"]').prop('checked', false);
                    //$('.form-group-apply_for_associate_membership').addClass('d-none');
                }
            }).change();

            $('[name="is_registered_in_australia"]').on('change', function () {
                $('.sup-company-abn').toggleClass('d-none', $(this).filter(':checked').val() === 'no');
            });
        }

        if ($('#form-create-user').length) {
            grecaptcha.ready(function() {
                grecaptcha.execute(rissb_var.recaptcha_site_key, {action: 'user_form'}).then(function(token) {
                    $('[name="recaptcha_token"]').val(token);
                });
            });

            $('[name="apply_type"]').on('change', function () {
                var role = $('[name="apply_type"]').filter(':checked').val();

                if (typeof role != 'undefined') {
                    $('.form-group-staff').toggleClass('d-none', role !== rissb_var.roles.staff);
                    $('.form-group-affiliate').toggleClass('d-none', role !== rissb_var.roles.affiliate);
                    $('[name="parent_company"]').chosen();
                }
            }).change();

            var $createUserForm = RISSB.fn.ajaxForm({
                form: '#form-create-user',
            });
        }
    });
})(jQuery);

